module.exports = __webpack_public_path__ + "static/media/ServiceImage.c9624499.png";